/**
 * Service-coverage — custom provincie-tooltip.
 *
 * Volgt het blok-JS-patroon (zoals faq/jobs): de module leeft bij het blok en
 * wordt expliciet geïmporteerd in resources/js/main.js. Self-init op DOM-ready,
 * initialiseert elke instance los en doet niets wanneer er geen kaart/provincies
 * zijn. Vanilla, geen deps.
 *
 * Vervangt de trage, ongestylede native <title>-tooltip door een eigen element
 * dat direct verschijnt: bij hover over een .service-coverage__province leest 'ie
 * de data-name en zweeft gecentreerd boven de cursor, meebewegend. De <title>s in
 * de SVG blijven staan (toegankelijkheid/fallback). De positie is relatief aan de
 * .service-coverage__map-wrap (position: relative), zodat de absolute tooltip
 * binnen die anker-box valt; de centrering + offset-omhoog zit in CSS.
 */

/**
 * Initialiseert één service-coverage-instance.
 *
 * @param {HTMLElement} root - De .service-coverage sectie.
 */
function initInstance(root) {
    const wrap = root.querySelector('.service-coverage__map-wrap');
    const tooltip = root.querySelector('.service-coverage__tooltip');
    if (!wrap || !tooltip) {
        return;
    }

    const provinces = root.querySelectorAll('.service-coverage__province');
    if (provinces.length === 0) {
        return;
    }

    const hide = () => {
        tooltip.hidden = true;
    };

    const move = (event) => {
        const rect = wrap.getBoundingClientRect();
        tooltip.style.left = `${event.clientX - rect.left}px`;
        tooltip.style.top = `${event.clientY - rect.top}px`;
    };

    const show = (province, event) => {
        const name = province.getAttribute('data-name') || '';
        if (name === '') {
            hide();
            return;
        }
        tooltip.textContent = name;
        tooltip.hidden = false;
        move(event);
    };

    provinces.forEach((province) => {
        province.addEventListener('mouseenter', (event) => show(province, event));
        province.addEventListener('mousemove', move);
        province.addEventListener('mouseleave', hide);
    });

    // Vangnet: de kaart in z'n geheel verlaten verbergt de tooltip ook.
    wrap.addEventListener('mouseleave', hide);
}

/**
 * Initialiseert alle service-coverage-blokken binnen een scope.
 *
 * @param {ParentNode} scope - Zoekwortel (default: document).
 */
export function initServiceCoverage(scope = document) {
    scope.querySelectorAll('.service-coverage').forEach(initInstance);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initServiceCoverage());
} else {
    initServiceCoverage();
}
